import { FC, useRef, useEffect, useState } from 'react'
import Image from 'next/image'

import { testimonialsBg, arrowLeft, arrowRight } from '@ui/assets'

interface Testimonial {
  text: string
  name: string
  rotate: string
}

const testimonials: Testimonial[] = [
  {
    text: "I earned as soon as I got there. I couldn't believe it.",
    name: 'Kris W.',
    rotate: '-1deg',
  },
  {
    text: "Awesome, way to earn a few dollars fast, but it's also an easy way to earn a lot of money if you have time.",
    name: 'Daine M.',
    rotate: '1deg',
  },
  {
    text: 'Helped me get a Bus pass to get to work the next day. Total Life Saver!',
    name: 'Terren B.',
    rotate: '-1deg',
  },
  {
    text: 'I downloaded the app on a whim when in need of a quick few bucks before payday.. super quick and easy process, money was in my account within a few minutes. The app is well designed and I like all the additional features of offers to earn extra cash, track and save your spending and credit builder help.',
    name: 'K J.',
    rotate: '1deg',
  },
  {
    text: "I've honestly made more money than I had expected this year using this app. As a matter of fact, I'm using said money for Christmas gifts! I have even referred ATM to friends! I definitely don't regret downloading it. 10/10.",
    name: 'Melissa W.',
    rotate: '-1deg',
  },
  {
    text: 'I have cashed out $100 in the first month playing games and doing surveys',
    name: 'Melanie H.',
    rotate: '1deg',
  },
  {
    text: 'They loaned me 25$ when I was really in a mess. Thanks ATM instant cash!',
    name: 'Stephany S.',
    rotate: '-1deg',
  },
  {
    text: "This app is AMAZING! It doesn't have a lot of red tape and PROMISES, it just DELIVERS!",
    name: 'Marla M.',
    rotate: '1deg',
  },
  {
    text: 'There are so many opportunities to earn money from engaging with their partners and some of the rewards are very generous.',
    name: 'Luke S.',
    rotate: '-1deg',
  },
  {
    text: "I'm actually having fun with this app. I am also being introduced to some apps that are extremely useful.",
    name: 'Lana O.',
    rotate: '1deg',
  },
  {
    text: "It's straight forward. Made easy. Why not have some fun & make some cash.",
    name: 'James P.',
    rotate: '-1deg',
  },
  {
    text: "This is the best app I have ever used to make money. They pay out and it's not difficult to cash out! Update.... it's still the best and easiest app to use for making money!",
    name: 'Dixie C.',
    rotate: '1deg',
  },
]

// TODO: audit these effects/initializations at some point
export const Testimonials: FC = () => {
  const [displayTestimonials, setDisplayTestimonials] = useState<
    typeof testimonials
  >([])
  const [isNearCarousel, setIsNearCarousel] = useState<boolean>(false)

  const carouselRef = useRef<HTMLDivElement>(null)

  //TODO: initializes testimonials should be done inside useState on component mount
  useEffect(() => {
    const shuffled = [...testimonials].sort(() => Math.random() - 0.5)
    // Create 5 copies for smooth infinite scroll with plenty of buffer
    setDisplayTestimonials([
      ...shuffled,
      ...shuffled,
      ...shuffled,
      ...shuffled,
      ...shuffled,
    ])
  }, [])

  // Initialize scroll position to middle set and handle infinite scroll
  useEffect(() => {
    const carousel = carouselRef.current
    if (!carousel || displayTestimonials.length === 0) return

    const itemWidth = 480 // card width + gap
    const singleSetWidth = itemWidth * testimonials.length

    // Start at the 3rd set (index 2) so we have buffer on both sides
    carousel.scrollLeft = singleSetWidth * 2

    let isRepositioning = false

    const handleScroll = () => {
      if (isRepositioning) return

      const scrollLeft = carousel.scrollLeft
      const maxScroll = carousel.scrollWidth - carousel.clientWidth

      // If we've scrolled into the 5th set, instantly jump back to 3rd set
      if (scrollLeft >= singleSetWidth * 4) {
        isRepositioning = true
        carousel.scrollLeft = scrollLeft - singleSetWidth * 2
        setTimeout(() => {
          isRepositioning = false
        }, 50)
      }
      // If we've scrolled into the 1st set, instantly jump forward to 3rd set
      else if (scrollLeft < singleSetWidth) {
        isRepositioning = true
        carousel.scrollLeft = scrollLeft + singleSetWidth * 2
        setTimeout(() => {
          isRepositioning = false
        }, 50)
      }
    }

    carousel.addEventListener('scroll', handleScroll, { passive: true })
    return () => carousel.removeEventListener('scroll', handleScroll)
  }, [displayTestimonials])

  const scrollCarousel = (direction: 'left' | 'right') => {
    if (carouselRef.current) {
      const scrollAmount = 480 // card width + gap
      const newScrollPosition =
        carouselRef.current.scrollLeft +
        (direction === 'right' ? scrollAmount : -scrollAmount)
      carouselRef.current.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth',
      })
    }
  }

  // Mouse proximity detection
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!carouselRef.current) return

      const rect = carouselRef.current.getBoundingClientRect()
      const proximity = 200 // pixels away to pause

      const isNear =
        e.clientY >= rect.top - proximity &&
        e.clientY <= rect.bottom + proximity &&
        e.clientX >= rect.left - proximity &&
        e.clientX <= rect.right + proximity

      setIsNearCarousel(isNear)
    }

    window.addEventListener('mousemove', handleMouseMove)
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [])

  // Autoscroll testimonials - slow and smooth
  useEffect(() => {
    if (
      !isNearCarousel &&
      carouselRef.current &&
      displayTestimonials.length > 0
    ) {
      const interval = setInterval(() => {
        if (carouselRef.current) {
          const scrollAmount = 1 // Scroll 1px at a time for smooth motion
          carouselRef.current.scrollLeft += scrollAmount
        }
      }, 20) // Update every 20ms for smooth 50fps animation

      return () => clearInterval(interval)
    }
  }, [isNearCarousel, displayTestimonials])

  return (
    <section className="relative overflow-hidden bg-[#0a2d4a] py-24 text-white">
      {/* Background image with overlay */}
      <div className="pointer-events-none absolute inset-0">
        <Image src={testimonialsBg} fill alt="" className="object-cover" />
        <div className="absolute inset-0 bg-black/30" />
      </div>

      <div className="relative z-10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="font-display mb-16 text-center text-5xl lg:text-6xl">
            Join <span className="text-[#2cceff]">1.5+ million</span> users
            improving
            <br />
            their financial futures
          </h2>
        </div>

        <div
          ref={carouselRef}
          className="scrollbar-hide mb-12 flex gap-5 overflow-x-auto px-4 [-ms-overflow-style:none] [scrollbar-width:none] sm:px-6 lg:px-8 [&::-webkit-scrollbar]:hidden"
        >
          {displayTestimonials.map((item, i) => (
            <div
              key={`${item.name.split(' ')[0]}-${i}`}
              className="w-full flex-shrink-0 sm:w-[380px] lg:w-[460px]"
              style={{ transform: `rotate(${item.rotate})` }}
            >
              <div
                className="flex flex-col gap-5 rounded-[20px] p-8"
                style={{
                  background:
                    'linear-gradient(180deg, rgb(255, 255, 255) 0.79523%, rgba(218, 241, 250, 0.7) 50.795%)',
                }}
              >
                {/* Stars */}
                <div className="flex gap-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <svg
                      key={star}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <defs>
                        <linearGradient
                          id={`star-gradient-${i}-${star}`}
                          x1="12"
                          y1="0"
                          x2="12"
                          y2="24"
                        >
                          <stop offset="0%" stopColor="#FFD700" />
                          <stop offset="100%" stopColor="#FFA500" />
                        </linearGradient>
                      </defs>
                      <path
                        d="M12 2L14.5 9L22 9.5L16.5 14.5L18.5 22L12 18L5.5 22L7.5 14.5L2 9.5L9.5 9L12 2Z"
                        fill={`url(#star-gradient-${i}-${star})`}
                      />
                    </svg>
                  ))}
                </div>

                {/* Content */}
                <div className="flex flex-col gap-5">
                  <p className="text-[18px] leading-[1.4] tracking-[-0.18px] text-[#0a2d4a]">
                    {item.text}
                  </p>
                </div>

                {/* Author */}
                <div className="flex items-center gap-3">
                  <p className="text-[16px] font-semibold leading-[1.3] tracking-[-0.16px] text-[#0a2d4a]">
                    {item.name}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <div className="inline-flex items-center gap-0 rounded-full bg-white p-1">
            <button
              onClick={() => scrollCarousel('left')}
              className="flex h-12 w-12 items-center justify-center rounded-full transition-colors hover:bg-gray-100"
              aria-label="Previous"
            >
              <div className="rotate-180 scale-y-[-100%]">
                <Image src={arrowLeft} width={24} height={24} alt="" />
              </div>
            </button>
            <button
              onClick={() => scrollCarousel('right')}
              className="flex h-12 w-12 items-center justify-center rounded-full bg-[#0a2d4a] transition-colors hover:bg-[#0a2d4a]/90"
              aria-label="Next"
            >
              <Image src={arrowRight} width={24} height={24} alt="" />
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
